import {
  CONFIG_STATUS_LEVEL,
  CONFIG_TYPES,
  CRM_CONDITION_TEMPLATE,
} from '../../../../common/constants/integrationConstants/crmConstants';
import {
  checkConditionUniquenes,
  findCondtionStatus,
  removeDuplicateEntry,
} from '../../../../common/util/crmIntegrationUtils/crmUtils';
import {
  deepCloneTemplate,
  generateConditionMap,
} from '../../../../common/util/reducerUtils/CrmReducerUtils';
import {
  addCondition,
  addConditionProperty,
  cancelCondition,
  cancelObjectType,
  changeConditionProperty,
  changeCrmObjectType,
  changeCrmPipeline,
  changeCrmStage,
  clearCrmStage,
  clearUnsavedChanges,
  createCondition,
  fetchCriterias,
  fetchCrmObjectProperties,
  removeCondition,
  removeConditionProperty,
  removeCrmStage,
} from '../../../routines/integrations/crmRoutines';

const initialState = {
  persistedStateObjectType: {},
  persistedStateConditions: {},
  [CONFIG_TYPES.OBJECT_TYPE]: {
    organization: {},
    account: {},
  },
  [CONFIG_TYPES.CONDITIONS]: {
    organization: {
      create: deepCloneTemplate(CRM_CONDITION_TEMPLATE),
      update: deepCloneTemplate(CRM_CONDITION_TEMPLATE),
      churn: deepCloneTemplate(CRM_CONDITION_TEMPLATE),
      archive: deepCloneTemplate(CRM_CONDITION_TEMPLATE),
    },
    account: {
      create: deepCloneTemplate(CRM_CONDITION_TEMPLATE),
      update: deepCloneTemplate(CRM_CONDITION_TEMPLATE),
      churn: deepCloneTemplate(CRM_CONDITION_TEMPLATE),
      archive: deepCloneTemplate(CRM_CONDITION_TEMPLATE),
    },
  },
  conditionLoading: false,
  error: null,
  duplicateCondition: [],
  hasUnSavedConfig: false,
};

const crmConditionReducer = (state = initialState, action) => {
  switch (action.type) {
    case changeCrmObjectType.TRIGGER: {
      const { objectType, entityLevel, criteriaType } = action.payload;
      const objectTypeConfig = { ...state[CONFIG_TYPES.OBJECT_TYPE] };
      const objectTypeConfigEntityLevel = { ...objectTypeConfig[entityLevel] };
      objectTypeConfigEntityLevel[criteriaType] = {
        type: objectType,
        status: CONFIG_STATUS_LEVEL.COMPLETED,
      };
      return {
        ...state,
        [CONFIG_TYPES.OBJECT_TYPE]: {
          ...objectTypeConfig,
          [entityLevel]: objectTypeConfigEntityLevel,
        },
        currentConfigType: CONFIG_TYPES.OBJECT_TYPE,
        hasUnSavedConfig: true,
      };
    }
    case changeCrmPipeline.TRIGGER: {
      const { entityLevel, criteriaType, conditionName, pipelineId } =
        action.payload;
      const olderPipelineId =
        state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType].conditions[
          conditionName
        ].pipeline;
      const newPipelineSelected = olderPipelineId !== pipelineId;
      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: {
              ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                .conditions,
              [conditionName]: {
                ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                  .conditions[conditionName],
                pipeline: pipelineId,
                stageFrom: newPipelineSelected
                  ? []
                  : state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                      .conditions[conditionName].stageFrom,
                stageTo: newPipelineSelected
                  ? []
                  : state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                      .conditions[conditionName].stageTo,
              },
            },
          },
        },
      };
      const {
        isIdenticalCondtions,
        entity: duplicateEntity,
        criteria: duplicateCriteria,
        conditionName: duplicateConditionName,
      } = checkConditionUniquenes(
        newConditionState[entityLevel][criteriaType].conditions[conditionName],
        entityLevel,
        criteriaType,
        newConditionState
      );
      const conditionStatus = findCondtionStatus(
        newConditionState[entityLevel][criteriaType].conditions
      );
      newConditionState[entityLevel][criteriaType].status = conditionStatus;
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        duplicateCondition: isIdenticalCondtions
          ? [
              ...state.duplicateCondition,
              [
                `${duplicateEntity}-${duplicateCriteria}-${duplicateConditionName}`,
                `${entityLevel}-${criteriaType}-${conditionName}`,
              ],
            ]
          : removeDuplicateEntry(entityLevel, criteriaType, conditionName, [
              ...state.duplicateCondition,
            ]),
        error: isIdenticalCondtions,
        hasUnSavedConfig: true,
      };
    }
    case changeCrmStage.TRIGGER: {
      const { entityLevel, criteriaType, conditionName, stage, side } =
        action.payload;
      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: {
              ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                .conditions,
              [conditionName]: {
                ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                  .conditions[conditionName],
                [`stage${side}`]: [
                  ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                    .conditions[conditionName][`stage${side}`],
                  stage,
                ],
              },
            },
          },
        },
      };
      const {
        isIdenticalCondtions,
        entity: duplicateEntity,
        criteria: duplicateCriteria,
        conditionName: duplicateConditionName,
      } = checkConditionUniquenes(
        newConditionState[entityLevel][criteriaType].conditions[conditionName],
        entityLevel,
        criteriaType,
        newConditionState
      );
      const conditionStatus = findCondtionStatus(
        newConditionState[entityLevel][criteriaType].conditions
      );
      newConditionState[entityLevel][criteriaType].status = conditionStatus;
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        duplicateCondition: isIdenticalCondtions
          ? [
              ...state.duplicateCondition,
              [
                `${duplicateEntity}-${duplicateCriteria}-${duplicateConditionName}`,
                `${entityLevel}-${criteriaType}-${conditionName}`,
              ],
            ]
          : removeDuplicateEntry(entityLevel, criteriaType, conditionName, [
              ...state.duplicateCondition,
            ]),
        error: isIdenticalCondtions,
        hasUnSavedConfig: true,
      };
    }
    case clearCrmStage.TRIGGER: {
      const { entityLevel, criteriaType, conditionName, side } = action.payload;
      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: {
              ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                .conditions,
              [conditionName]: {
                ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                  .conditions[conditionName],
                [`stage${side}`]: [],
              },
            },
          },
        },
      };
      const conditionStatus = findCondtionStatus(
        newConditionState[entityLevel][criteriaType].conditions
      );
      newConditionState[entityLevel][criteriaType].status = conditionStatus;
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        hasUnSavedConfig: false,
      };
    }
    case removeCrmStage.TRIGGER: {
      const { entityLevel, criteriaType, conditionName, stageValue, side } =
        action.payload;
      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: {
              ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                .conditions,
              [conditionName]: {
                ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                  .conditions[conditionName],
                [`stage${side}`]: [
                  ...state[CONFIG_TYPES.CONDITIONS][entityLevel][
                    criteriaType
                  ].conditions[conditionName][`stage${side}`].filter(
                    (stage) => stage !== stageValue
                  ),
                ],
              },
            },
          },
        },
      };
      const {
        isIdenticalCondtions,
        entity: duplicateEntity,
        criteria: duplicateCriteria,
        conditionName: duplicateConditionName,
      } = checkConditionUniquenes(
        newConditionState[entityLevel][criteriaType].conditions[conditionName],
        entityLevel,
        criteriaType,
        newConditionState
      );
      const conditionStatus = findCondtionStatus(
        newConditionState[entityLevel][criteriaType].conditions
      );
      newConditionState[entityLevel][criteriaType].status = conditionStatus;
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        duplicateCondition: isIdenticalCondtions
          ? [
              ...state.duplicateCondition,
              [
                `${duplicateEntity}-${duplicateCriteria}-${duplicateConditionName}`,
                `${entityLevel}-${criteriaType}-${conditionName}`,
              ],
            ]
          : removeDuplicateEntry(entityLevel, criteriaType, conditionName, [
              ...state.duplicateCondition,
            ]),
        error: isIdenticalCondtions,
        hasUnSavedConfig: true,
      };
    }
    case changeConditionProperty.TRIGGER: {
      const {
        entityLevel,
        criteriaType,
        conditionName,
        property: { propertyIndex, propertyValue },
      } = action.payload;
      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: {
              ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                .conditions,
              [conditionName]: {
                ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                  .conditions[conditionName],
                properties: {
                  ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                    .conditions[conditionName].properties,
                  [propertyIndex]: {
                    ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                      .conditions[conditionName].properties[propertyIndex],
                    propertyValue,
                  },
                },
              },
            },
          },
        },
      };
      const {
        isIdenticalCondtions,
        entity: duplicateEntity,
        criteria: duplicateCriteria,
        conditionName: duplicateConditionName,
      } = checkConditionUniquenes(
        newConditionState[entityLevel][criteriaType].conditions[conditionName],
        entityLevel,
        criteriaType,
        newConditionState
      );
      const conditionStatus = findCondtionStatus(
        newConditionState[entityLevel][criteriaType].conditions
      );
      newConditionState[entityLevel][criteriaType].status = conditionStatus;
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        duplicateCondition: isIdenticalCondtions
          ? [
              ...state.duplicateCondition,
              [
                `${duplicateEntity}-${duplicateCriteria}-${duplicateConditionName}`,
                `${entityLevel}-${criteriaType}-${conditionName}`,
              ],
            ]
          : removeDuplicateEntry(entityLevel, criteriaType, conditionName, [
              ...state.duplicateCondition,
            ]),
        error: isIdenticalCondtions,
        hasUnSavedConfig: true,
      };
    }

    case addConditionProperty.TRIGGER: {
      const {
        entityLevel,
        criteriaType,
        conditionName,
        propertyIndex,
        propertyId,
        objectType,
        propertyValue,
      } = action.payload;
      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: {
              ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                .conditions,
              [conditionName]: {
                ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                  .conditions[conditionName],
                properties: {
                  ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                    .conditions[conditionName].properties,
                  [propertyIndex]: {
                    propertyIndex,
                    propertyId,
                    objectType,
                    propertyValue,
                  },
                },
              },
            },
          },
        },
      };
      newConditionState[entityLevel][criteriaType].status =
        CONFIG_STATUS_LEVEL.IN_PROGRESS;
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        hasUnSavedConfig: true,
      };
    }
    case addCondition.TRIGGER: {
      const { entityLevel, criteriaType, conditionName } = action.payload;
      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: {
              ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                .conditions,
              [conditionName]: {
                conditionName,
                stageFrom: [],
                stageTo: [],
                properties: {},
              },
            },
          },
        },
      };
      newConditionState[entityLevel][criteriaType].status =
        CONFIG_STATUS_LEVEL.IN_PROGRESS;
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        hasUnSavedConfig: true,
      };
    }

    case removeCondition.TRIGGER: {
      const { entityLevel, criteriaType, conditionName } = action.payload;
      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: {
              ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                .conditions,
            },
          },
        },
      };
      delete newConditionState[entityLevel][criteriaType].conditions[
        conditionName
      ];
      const conditionStatus = findCondtionStatus(
        newConditionState[entityLevel][criteriaType].conditions
      );
      newConditionState[entityLevel][criteriaType].status = conditionStatus;
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        duplicateCondition: removeDuplicateEntry(
          entityLevel,
          criteriaType,
          conditionName,
          [...state.duplicateCondition]
        ),
        hasUnSavedConfig: true,
      };
    }
    case removeConditionProperty.TRIGGER: {
      const { entityLevel, criteriaType, conditionName, propertyIndex } =
        action.payload;
      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: {
              ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                .conditions,
              [conditionName]: {
                ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                  .conditions[conditionName],
                properties: {
                  ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType]
                    .conditions[conditionName].properties,
                },
              },
            },
          },
        },
      };
      delete newConditionState[entityLevel][criteriaType].conditions[
        conditionName
      ].properties[propertyIndex];
      const {
        isIdenticalCondtions,
        entity: duplicateEntity,
        criteria: duplicateCriteria,
        conditionName: duplicateConditionName,
      } = checkConditionUniquenes(
        newConditionState[entityLevel][criteriaType].conditions[conditionName],
        entityLevel,
        criteriaType,
        newConditionState
      );
      const conditionStatus = findCondtionStatus(
        newConditionState[entityLevel][criteriaType].conditions
      );
      newConditionState[entityLevel][criteriaType].status = conditionStatus;
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        duplicateCondition: isIdenticalCondtions
          ? [
              ...state.duplicateCondition,
              [
                `${duplicateEntity}-${duplicateCriteria}-${duplicateConditionName}`,
                `${entityLevel}-${criteriaType}-${conditionName}`,
              ],
            ]
          : removeDuplicateEntry(entityLevel, criteriaType, conditionName, [
              ...state.duplicateCondition,
            ]),
        error: isIdenticalCondtions,
        hasUnSavedConfig: true,
      };
    }
    case createCondition.TRIGGER:
      return {
        ...state,
        error: null,
      };
    case fetchCriterias.TRIGGER:
      return {
        ...state,
        conditionLoading: true,
        error: false,
      };
    case cancelCondition.TRIGGER: {
      const previousConditionState = JSON.parse(
        JSON.stringify(state.persistedStateConditions)
      );
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: previousConditionState,
        hasUnSavedConfig: false,
      };
    }
    case cancelObjectType.TRIGGER: {
      const previousObjectState = JSON.parse(
        JSON.stringify(state.persistedStateObjectType)
      );
      return {
        ...state,
        [CONFIG_TYPES.OBJECT_TYPE]: previousObjectState,
        hasUnSavedConfig: false,
      };
    }
    case fetchCrmObjectProperties.SUCCESS: {
      const { dealProperties, companyProperties, pipelines } = action.payload;
      return {
        ...state,
        propertyFetchLoading: false,
        dealProperties,
        companyProperties,
        pipelines,
      };
    }
    case fetchCriterias.SUCCESS: {
      const criteriaMap = action.payload;
      // Constructing CRM object type map
      let objectTypeMap = {};
      Object.keys(criteriaMap).forEach((entityLevel) => {
        Object.keys(criteriaMap[entityLevel]).forEach((criteriaType) => {
          objectTypeMap = {
            ...objectTypeMap,
            [entityLevel]: {
              ...(objectTypeMap[entityLevel] || {}),
              [criteriaType]: {
                type: criteriaMap[entityLevel][criteriaType].objectType,
                status: criteriaMap[entityLevel][criteriaType].status,
              },
            },
          };
        });
      });
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: criteriaMap,
        [CONFIG_TYPES.OBJECT_TYPE]: objectTypeMap,
        persistedStateConditions: criteriaMap,
        persistedStateObjectType: objectTypeMap,
        conditionLoading: false,
        hasUnSavedConfig: false,
      };
    }
    case createCondition.SUCCESS: {
      const {
        entityLevel,
        criteria: criteriaType,
        objectType,
        conditions,
        status,
      } = action.payload;

      const newConditionState = {
        ...state[CONFIG_TYPES.CONDITIONS],
        [entityLevel]: {
          ...state[CONFIG_TYPES.CONDITIONS][entityLevel],
          [criteriaType]: {
            ...state[CONFIG_TYPES.CONDITIONS][entityLevel][criteriaType],
            conditions: generateConditionMap(conditions),
            status,
          },
        },
      };

      const newObjectState = {
        ...state[CONFIG_TYPES.OBJECT_TYPE],
        [entityLevel]: {
          ...state[CONFIG_TYPES.OBJECT_TYPE][entityLevel],
          [criteriaType]: {
            type: objectType,
            status: CONFIG_STATUS_LEVEL.SAVED,
          },
        },
      };
      return {
        ...state,
        [CONFIG_TYPES.CONDITIONS]: newConditionState,
        [CONFIG_TYPES.OBJECT_TYPE]: newObjectState,
        persistedStateConditions: newConditionState,
        persistedStateObjectType: newObjectState,
        conditionLoading: false,
        hasUnSavedConfig: false,
      };
    }
    case createCondition.FAILURE:
    case fetchCriterias.FAILURE:
      return {
        ...state,
        conditionLoading: false,
        error: action.payload.error,
        hasUnSavedConfig: false,
      };
    case clearUnsavedChanges.TRIGGER: {
      const { hasUnSavedConfig } = { ...state };

      if (hasUnSavedConfig) {
        const previousObjectState = JSON.parse(
          JSON.stringify(state.persistedStateObjectType)
        );
        const previousConditionState = JSON.parse(
          JSON.stringify(state.persistedStateConditions)
        );
        return {
          ...state,
          [CONFIG_TYPES.OBJECT_TYPE]: previousObjectState,
          [CONFIG_TYPES.CONDITIONS]: previousConditionState,
          hasUnSavedConfig: false,
        };
      }
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};

export default crmConditionReducer;
